module.exports = __webpack_public_path__ + "img/clock.15c03842.svg";